import BaseReduction from './BaseReduction';

// ---------------------------------------- BaseHorseReduction ----------------------------------------

export default class BaseHorseReduction extends BaseReduction {
  constructor() {
    super(...arguments);
    this.ensureInteger('minWinners', -1);
    this.ensureInteger('maxWinners', -1);
  }

  isEmpty() {
    return this.getMinWinners() === -1 && this.getMaxWinners() === -1
      ? true
      : false;
  }

  getMinWinners() {
    return this.getInteger('minWinners', -1);
  }
  setMinWinners(v) {
    this.invalidate();
    return this.setInteger('minWinners', v);
  }

  getMaxWinners() {
    return this.getInteger('maxWinners', -1);
  }
  setMaxWinners(v) {
    this.invalidate();
    return this.setInteger('maxWinners', v);
  }

  getComment() {
    return this.getString('comment');
  }
  setComment(v) {
    this.invalidate();
    return this.setString('comment', v);
  }
}
